import client from './client';

export const getBusinessSettings = (businessUuid) =>
  client.get(`/business-settings/${businessUuid}`).then((r) => r.data);

export const updateBusinessSettings = (businessUuid, data) =>
  client.put(`/business-settings/${businessUuid}`, data).then((r) => r.data);
